import * as actionTypes from '../actions/actionTypes';
import * as constants from '../../constants';

import { updateState } from '../../lib/StateHelper';

const initialState = {
  franchiseRoyaltyPlan: null,
  franchiseRoyaltyPlans: null,
  isNew: false,
  lastState: null,
  lastScope: null
};

const franchiseRoyaltyPlanReducer = (state = initialState, action) => {
  switch(action.type) {
    case actionTypes.FRANCHISEROYALTYPLAN_START: {
      return updateState(state, { ...action.data, lastState: constants.STATE_PROCESSING });
    }
    case actionTypes.FRANCHISEROYALTYPLAN_SUCCESS: {
      return updateState(state, { ...action.data, lastState: constants.STATE_SUCCESS });
    }
    case actionTypes.FRANCHISEROYALTYPLAN_FAIL: {
      return updateState(state, { lastState: constants.STATE_FAIL });
    }
    default: {
      return state;
    }
  }
};

export default franchiseRoyaltyPlanReducer;
